<template>
  <div>
    <div v-if="!error">
      <DesktopCompany
        :logo="logo"
        :numOfEmployees="numOfEmployees"
        :industry="industry"
        :numOfBranches="numOfBranches"
        :benefits="benefits"
        :CustomBenefit="CustomBenefit"
        :companyName="companyName"
        :companyCode="companyCode"
        :companyDisplayUrl="companyDisplayUrl"
        :testimonials="testimonials"
        :screenWidth="screenWidth"
        :categories="categories"
        :images="images"
        :lat="latitude"
        :lng="longitude"
        :description="description"
        :address="address"
        :jobs="jobs"
        :showMoreJobs="showMoreJobs"
        :seo="seodata.breadcrumbs"
      />
    </div>
    <CvConfirmation />
  </div>
</template>

<script>
import DesktopCompany from '@/components/Company/DesktopCompany';
import drushim_lodash from 'lodash';
import SeoOptimization from '@/components/mixins/SeoOptimization';
import CvConfirmation from '@/components/Dialogs/CvConfirmation/CvConfirmation';

export default {
  mixins: [SeoOptimization],
  name: 'companyPage',
  layout: 'innerPage',

  components: {
    DesktopCompany,
    CvConfirmation
  },

  data() {
    return {
      screenWidth: null,
      isMobile: false
    };
  },
  created() {},

  mounted() {
    if (!this.error) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      drushim_lodash.isEmpty(this.ssaData) ? null : this.sendSSA(this.ssaData);
      this.showMoreJobs;
    } else {
      this.$router.push('/404');
    }
  },

  async asyncData(context) {
    try {
      let re = new RegExp(
        '^\u05d3\u05e8\u05d5\u05e9\u05d9\u05dd-([0-9]+)-([^/]+)'
      );
      let urlParse = decodeURI(context.route.path.split('/'));
      urlParse = urlParse.replace(/,/g, '');
      var match = re.exec(urlParse);
      const companyCode = match[1];
      const companyName = encodeURI(match[2]);

      let { data } = await context.$axios.get(
        `${
          process.env.baseUrl
        }/api/company/profile/?companycode=${companyCode}&companyname=${companyName}`
      );

      if (data.IsError) {
        throw data.Errors;
      }

      if (data.IsRedirect) {
        let redirectUrl = data.RedirectTo ? data.RedirectTo : '/';
        context.redirect(307, redirectUrl);
        return;
      }

      return {
        // missing numOfBranches
        error: data.IsError,
        images: data.Company.PageHeaderImagesLinks,
        companyName: data.Company.NameInHebrew,
        companyCode: companyCode,
        companyDisplayUrl: data.Company.DisplayUrl,
        numOfEmployees: data.Company.NumberOfEmployees,
        isMapDisplayed: data.Company.IsMapDisplayed,
        numOfBranches: null,
        industry: data.Company.Industry,
        benefits: data.Company.Benefits,
        CustomBenefit: data.Company.CustomBenefit,
        testimonials: data.Company.Testimonials,
        categories: data.Company.Categories,
        address: data.Company.Address,
        description: data.Company.Description,
        logo: data.Company.CompanyLogoLink,
        jobs: data.Company.Jobs,
        latitude: data.Company.Latitude,
        longitude: data.Company.Longitude,
        ssaData: data.SSAEvents,
        seodata: {
          metaData: data.SEO.MetaDataItems,
          pageTitle: data.SEO.title,
          breadcrumbs: data.SEO.BreadCrumbs.Keys,
          canonicalUrl: data.SEO.CanonicalUrl,
          breadCrumbsSchema: {
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: [
              {
                '@type': 'ListItem',
                position: 1,
                name: 'Home page',
                item: 'https://www.drushim.co.il/'
              },
              {
                '@type': 'ListItem',
                position: 2,
                name: data.SEO.title,
              }
            ]
          }
        }
      };
    } catch (e) {
      console.log('company error page ', e);
      context.redirect(307, '/');
    }
  },
  head() {
    return {
      link: [
        {
          rel: 'canonical',
          href: decodeURI(this.seodata.canonicalUrl)
        }
      ],
      title: this.seodata.pageTitle,
      meta: this.seodata.metaData,
      __dangerouslyDisableSanitizers: ['script'],
      script: [
        {
          innerHTML: JSON.stringify(this.seodata.breadCrumbsSchema),
          type: 'application/ld+json'
        }
      ]
    };
  },
  computed: {
    ssa() {
      return drushim_lodash.get(this.$ssa, 'vm', {});
    },
    showMoreJobs() {
      return this.jobs.length > 5 ? true : false;
    }
  },

  methods: {
    sendSSA(evenData) {
      this.ssa.logResponse('LogSSA', evenData);
    }
  }
};
</script>

<style lang="scss" scoped>
#googlemaps {
  height: 728px;
  width: 100%;
  position: absolute;
  top: 800px;
  left: 0;
  z-index: 0; /* Set z-index to 0 as it will be on a layer below the contact form */
}

#description {
  position: relative;
  z-index: 1; /* The z-index should be higher than Google Maps */
  margin: 60px auto 0;
  padding: 10px;
  background: white;
  height: auto;
  color: $company-gray;
}
</style>
